import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { DateTime } from "../../../domain/fundamental/DateTime";
import { useMemo } from "react";
import { UserId } from "../../../domain/user/UserId";
import { UserName } from "../../../domain/user/UserName";
import { UserEmail } from "../../../domain/user/UserEmail";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../domain/care_recipient/CareRecipientHouseId";
import { InquiryDetail } from "../../../domain/inquiry/InquiryDetail";
import { InquiryId } from "../../../domain/inquiry/InquiryId";
import { InquiryCategory } from "../../../domain/inquiry/InquiryCategory";
import { InquiryContent } from "../../../domain/inquiry/InquiryContent";
import { InquiryMemo } from "../../../domain/inquiry/InquiryMemo";

export const useInquiryDetail = (): ReturnType => {
    const { inquiryDetail: responseJson, processingGetInquiry: processCount } = useSelector((state: State) => state.inquiry);

    const inquiry = useMemo(() => {
        if (!responseJson) {
            return null;
        }
        let user;
        if (responseJson.user === null) {
            user = null;
        } else {
            user = {
                id: UserId.fromString(responseJson.user.id),
                name: UserName.fromString(responseJson.user.name),
                email: UserEmail.fromString(responseJson.user.email)
            };
        }
        let careRecipient;
        if (responseJson.careRecipient === null) {
            careRecipient = null;
        } else {
            careRecipient = {
                id: CareRecipientId.fromString(responseJson.careRecipient.id),
                name: CareRecipientName.fromString(responseJson.careRecipient.name),
                houseId: CareRecipientHouseId.fromString(responseJson.careRecipient.houseId)
            };

        }
        return InquiryDetail.from(
            InquiryId.fromString(responseJson.id),
            user,
            careRecipient,
            DateTime.fromString(responseJson.createdAt),
            InquiryCategory.fromString(responseJson.category),
            responseJson.status,
            InquiryContent.fromString(responseJson.content),
            responseJson.tel,
            responseJson.memo ? InquiryMemo.fromString(responseJson.memo) : null,
            UserEmail.fromString(responseJson.contactEmail)
        );
    }, [responseJson]);

    const processing = processCount > 0;

    return { inquiry, processing };
};

type ReturnType = {
    inquiry: InquiryDetail | null,
    processing: boolean
}
